import { render } from "./BaseSmallAmountTitle.vue?vue&type=template&id=01f0d5c4&scoped=true"
import script from "./BaseSmallAmountTitle.vue?vue&type=script&lang=js"
export * from "./BaseSmallAmountTitle.vue?vue&type=script&lang=js"

import "./BaseSmallAmountTitle.vue?vue&type=style&index=0&id=01f0d5c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f0d5c4"],['__file',"src/components/helpers/BaseSmallAmountTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01f0d5c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01f0d5c4', __exports__)) {
    api.reload('01f0d5c4', __exports__)
  }
  
  module.hot.accept("./BaseSmallAmountTitle.vue?vue&type=template&id=01f0d5c4&scoped=true", () => {
    api.rerender('01f0d5c4', render)
  })

}


export default __exports__